import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../supabaseClient'

function TopRanked() {
  const [rankedLures, setRankedLures] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchTopRanked()
  }, [])

  const fetchTopRanked = async () => {
    try {
      // Fetch all reviews with base lure info
      const { data: reviewsData, error } = await supabase
        .from('lure_reviews')
        .select(`
          rating,
          base_lure_id,
          base_lures (
            base_lure_id,
            name,
            brands (brand_name),
            lure_types (type_name)
          )
        `)

      if (error) throw error

      // Calculate average ratings per base lure
      const lureRatings = {}
      
      reviewsData.forEach(review => {
        const baseLureId = review.base_lure_id
        if (!lureRatings[baseLureId]) {
          lureRatings[baseLureId] = {
            baseLure: review.base_lures,
            ratings: [],
            count: 0
          }
        }
        lureRatings[baseLureId].ratings.push(review.rating)
        lureRatings[baseLureId].count++
      })

      // Calculate averages and create ranked list
      const ranked = Object.entries(lureRatings)
        .map(([_baseLureId, data]) => ({
          base_lure_id: data.baseLure.base_lure_id,
          name: data.baseLure.name,
          brand: data.baseLure.brands?.brand_name,
          type: data.baseLure.lure_types?.type_name,
          avgRating: (data.ratings.reduce((a, b) => a + b, 0) / data.ratings.length).toFixed(2),
          reviewCount: data.count
        }))
        .sort((a, b) => b.avgRating - a.avgRating)
        .slice(0, 100) // Top 100

      setRankedLures(ranked)
      setLoading(false)
    } catch (error) {
      console.error('Error fetching rankings:', error)
      setLoading(false)
    }
  }

  if (loading) {
    return <div className="loading">Loading rankings...</div>
  }

  return (
    <div className="top-ranked-page">
      <div className="page-header">
        <h1>Top Ranked Lures</h1>
        <p className="page-subtitle">
          Community rankings based on user reviews and ratings
        </p>
      </div>

      {rankedLures.length === 0 && (
        <div className="no-data">
          <p>No rankings available yet. Be the first to review some lures!</p>
          <Link to="/browse" className="btn-primary">Browse Lures</Link>
        </div>
      )}

      {rankedLures.length > 0 && (
        <div className="rankings-table">
          <div className="rankings-header">
            <div className="rank-col">Rank</div>
            <div className="lure-col">Lure</div>
            <div className="rating-col">Avg Rating</div>
            <div className="reviews-col">Reviews</div>
          </div>

          {rankedLures.map((lure, index) => (
            <Link 
              to={`/lure/${lure.base_lure_id}`} 
              key={lure.base_lure_id}
              className="ranking-row"
            >
              <div className="rank-col">
                <span className="rank-number">#{index + 1}</span>
              </div>
              <div className="lure-col">
                <div className="lure-name">{lure.name}</div>
                <div className="lure-meta">{lure.brand} | {lure.type}</div>
              </div>
              <div className="rating-col">
                <span className="rating-badge">{lure.avgRating}/10</span>
              </div>
              <div className="reviews-col">
                {lure.reviewCount} {lure.reviewCount === 1 ? 'review' : 'reviews'}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}

export default TopRanked